import { MarketPlace } from "@/api/types/main/schemas";
import { FC } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

interface PromotionsCardProps {
  promotions: string[];
  marketplace: MarketPlace;
}

export const PromotionsCard: FC<PromotionsCardProps> = ({ promotions, marketplace }) => {
  const marketplaceStyles = {
    [MarketPlace.OZON]: "bg-blue-600",
    [MarketPlace.WB]: "bg-fuchsia-600",
    [MarketPlace.YM]: "bg-gold-600",
  };
  return (
    <>
      {promotions.map((campaign, idx) => (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                key={idx}
                className={`flex ${marketplaceStyles[marketplace]} text-white p-1 rounded`}
              >
                <span className="truncate">{campaign}</span>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{campaign}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ))}
    </>
  );
};
